/* eslint-disable multiline-ternary */
import React from 'react'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { contentSlice } from '../../reducers'
import Header from './header'
import Container from '../container'
import VideoPlayer from '../video-player'
import { ArticleBodyLoading } from '../article-view/article-view-loading'
import Body from '../article/body'
import { useStyles } from './style'

const CornerstoneArticleView = () => {
  const content = useSelector(contentSlice.selectors.selectContent)

  const classes = useStyles()

  if (window.DD_RUM && typeof window.DD_RUM.addTiming === 'function') {
    window.DD_RUM.addTiming('article_view_loaded')
  } else {
    console.log('addTiming is not available')
  }

  if (!content) return null

  return (
    <div id={content.locationId} className={classes.contentGrid}>
      <Box className={classes.content}>
        <Container
          maxContentWidth={668}
          inset={2}
          classes={{ content: classes.article }}
          className={classes.container}
        >
          <Header
            content={content}
          />
          <VideoPlayer url={content?.videoUrl} />
          <React.Suspense fallback={<ArticleBodyLoading />}>
            <Body
              body={content?.body}
              className={classes.body}
            />
          </React.Suspense>
        </Container>
      </Box>
    </div>
  )
}

export default CornerstoneArticleView
